export const PLAN_TYPES = {
  tariff: 'tariff',
  document: 'document',
  bonus: 'bonus'
}

export const planTypesUkMap = {
  [PLAN_TYPES.tariff]: 'Тариф',
  [PLAN_TYPES.document]: 'Додаткові документи',
  [PLAN_TYPES.bonus]: 'Бонусний'
}

export const INVOICE_STATUSES = {
  created: 'created',
  paid: 'paid',
  cancelled: 'cancelled'
}

export const PAYMENT_STATUSES = {
  new: 'new',
  error: 'error',
  parsed: 'parsed'
}

export const FREE_PLAN_ID = '63dc6222-752b-4da2-a633-bb6cb8ca475c'
export const PREMIUM_PLAN_ID = 'fbfe5b43-7e18-4a4a-a7d2-0e90690f117d'
export const INDIVIDUAL_PREMIUM_PLAN_ID = 'dc6507ac-f851-4919-97fa-63212ca66717'

export const invoiceStatuses = [
  {
    value: 'paid',
    text: 'Оплачений',
    background: 'rgba(33, 150, 83, 0.08)',
    color: '#219653'
  },
  {
    value: 'created',
    text: 'Створений',
    background: 'rgba(255, 170, 1, 0.08)',
    color: '#FFAA01'
  },
  {
    value: 'cancelled',
    text: 'Скасовано',
    background: 'rgba(255, 23, 68, 0.08)',
    color: '#FF1744'
  }
]

export const paymentStatuses = [
  {
    value: 'parsed',
    text: 'Рознесений',
    background: 'rgba(33, 150, 83, 0.08)',
    color: '#219653'
  },
  {
    value: 'new',
    text: 'Новий',
    background: 'rgba(255, 170, 1, 0.08)',
    color: '#FFAA01'
  },
  {
    value: 'error',
    text: 'Помилка',
    background: 'rgba(255, 23, 68, 0.08)',
    color: '#FF1744'
  }
]

export const periodStatuses = [
  {
    value: 'active',
    text: 'Активний',
    background: 'rgba(33, 150, 83, 0.08)',
    color: '#219653'
  },
  {
    value: 'upgraded',
    text: 'Оновлений до преміум',
    background: 'rgba(255, 170, 1, 0.08)',
    color: '#FFAA01'
  },
  {
    value: 'expired',
    text: 'Закінчений',
    background: 'rgba(255, 23, 68, 0.08)',
    color: '#FF1744'
  },
  {
    value: 'upcoming',
    text: 'Майбутній',
    background: 'rgba(143, 37, 125, 0.08)',
    color: '#8F257DFF'
  }
]

export const BILLING_TABS = {
  overview: 'overview',
  plans: 'plans',
  invoices: 'invoices',
  acts: 'acts'
}
